







import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import { Sponsor } from '@/models/sponsor';
import { urlize } from '@/utils';

import Bro from 'brototype';

@Component
export default class SponsorCard extends Vue {
    @Prop(Object) public sponsor: Sponsor;

    get backgroundImage() {
        if (navigator.onLine && Bro(this.sponsor).doYouEven('image.medium')) {
            const url = urlize(this.sponsor.image.medium);
            return {
                'background-image': `url('${url}')`,
                'background-size': 'cover',
            };
        }
        return '';
    }
}
